export default "__VITE_ASSET__1894b77e__"